import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function ImportacionMasivaDeGuias() {
  return (
    <ClipperPlaceholder title="Importación Masiva de Guías" category="Operativas" />
  );
}
